
// Modal Backdrop
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  [data-theme='dark'] & {
    background: rgba(0, 0, 0, 0.7);
  }
}

// Add New Type Modal Content
.modal {
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

// Search Section with TypeAhead
.search {
  display: flex;
  align-items: stretch;
  gap: map.get($spacing-scale, 'md');
  padding: map.get($spacing-scale, 'lg');
}

.typeAheadWrapper {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
}

.lookupBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: map.get($spacing-scale, 'sm');
  padding: map.get($spacing-scale, 'md');
  background: var(--color-primary-base);
  border: none;
  border-radius: map.get($radius, 'md');
  color: white;
  cursor: pointer;
  @include body-medium;
  flex-shrink: 0;
  height: 52px;
  white-space: nowrap;

  @include transition(background-color, transform, box-shadow);

  &:hover:not(:disabled) {
    background: var(--color-primary-dark);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(95, 91, 243, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    flex-shrink: 0;
  }
}

// Empty State
.empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px map.get($spacing-scale, 'lg');
  gap: map.get($spacing-scale, 'md');
}

.emptyText {
  @include body-regular;
  color: var(--color-text-secondary);
  margin: 0;
}

// Loading State
.loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px map.get($spacing-scale, 'lg');
}

.loadingSpinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loadingText {
  @include body-regular;
  color: var(--color-text-secondary);
  margin: map.get($spacing-scale, 'lg') 0 0 0;
}

// Results State
.results {
  padding: 0 map.get($spacing-scale, 'lg') map.get($spacing-scale, 'lg') map.get($spacing-scale, 'lg');
  margin-left: map.get($spacing-scale, 'lg');
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'lg');
  max-height: 500px;
  overflow-y: auto;
  border-left: 4px solid var(--color-semantic-container-accent);
}

.resultsHeader {
  // Header section styling (no border here - it's on .results container)
}

.resultsTitle {
  @include heading-4;
  margin: 0;
  color: var(--color-text-primary);
}

.resultsSubtitle {
  @include body-small-regular;
  color: var(--color-text-secondary);
  margin: map.get($spacing-scale, 'xs') 0 0 0;
}

// Section
.section {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'sm');
}

.sectionHeader {
  display: flex;
  align-items: center;
  gap: map.get($spacing-scale, 'xs');

  svg {
    color: var(--color-primary-base);
    flex-shrink: 0;
  }
}

.sectionTitle {
  @include body-bold;
  margin: 0;
  color: var(--color-text-primary);
}

// Items
.items {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'md');
}

.item {
  @include body-small-regular;
  padding: map.get($spacing-scale, 'md');
  background: var(--color-grey-light);
  border-radius: map.get($radius, 'md');
  color: var(--color-text-secondary);

  [data-theme='dark'] & {
    background: var(--color-surface-alt);
  }
}

// Editable Input - overrides for Input component in results state
.editableInput {
  // Default state: white background with grey border (per Figma node-id=553-2909)
  background-color: var(--color-surface-primary);
  border: 1px solid var(--color-grey-neutral);

  // Focused state: primary border (per Figma node-id=553-2910)
  &:focus-within {
    border-color: var(--color-primary-base);
  }
}

// Responsive adjustments
@media (max-width: $breakpoint-md) {
  .search {
    flex-direction: column;
  }

  .lookupBtn {
    width: 100%;
    justify-content: center;
  }

  .results {
    max-height: 400px;
  }
}
